import { ConfirmModal } from '@/components/modal/ConfirmModal'

type Props = {
  onConfirm: () => void
  onCancel: () => void
}

export const DeleteConfirmModal = ({ onConfirm, onCancel }: Props) => {
  return (
    <ConfirmModal
      title="削除"
      titleColor="red"
      message="削除してよろしいですか？"
      confirmLabel="削除する"
      cancelLabel="いいえ"
      confirmColor="danger"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}
